export const isDevEnv = tier => {
  return ['develop', 'redseries', 'greenapple', 'galaxy', 'khamoo', 'khaohom', 'integration'].includes(tier);
};
